import {
    CLEAR_CREDENTIALS, EMPTY_AUTH,
    FETCH_LOGGED_IN_USER, FETCH_LOGGED_IN_USER_SUCCESS, FETCH_LOGGED_IN_USER_FAILURE,
    FETCH_LOGIN, FETCH_LOGIN_SUCCESS, FETCH_LOGIN_SUCCESS_NOT_ADMIN, FETCH_LOGIN_FAILURE,
    FETCH_RESET_PASSWORD, FETCH_RESET_PASSWORD_SUCCESS, FETCH_RESET_PASSWORD_FAILURE,
    SET_CREDENTIALS, SET_RESET_PASSWORD_DATA, SET_USER, SET_TOKEN, UPDATE_AUTH
} from './constants';

const emptyCredentials = {
    email: '',
    password: ''
};

const emptyResetPasswordData = {
    password: '',
    password2: ''
};

const initialState = {
    credentials: JSON.parse(JSON.stringify(emptyCredentials)),
    resetPasswordData: JSON.parse(JSON.stringify(emptyResetPasswordData)),
    user: null,
    isFetching: false,
    isResettingPassword: false,
    error: {},
    resetPasswordError: {},
    token: ''
};

function authReducer(state = initialState, action) {
    switch(action.type) {
        case CLEAR_CREDENTIALS:
            return Object.assign({}, state, {
                credentials: JSON.parse(JSON.stringify(emptyCredentials))
            });
        case EMPTY_AUTH:
            return initialState;
        case FETCH_LOGGED_IN_USER:
        case FETCH_LOGIN:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_LOGGED_IN_USER_SUCCESS:
        case FETCH_LOGIN_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                user: action.data,
            });
        case FETCH_LOGIN_SUCCESS_NOT_ADMIN:
            return Object.assign({}, state, {
                isFetching: false
            });
        case FETCH_LOGGED_IN_USER_FAILURE:
        case FETCH_LOGIN_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case FETCH_RESET_PASSWORD:
            return Object.assign({}, state, {
                isResettingPassword: true,
                resetPasswordError: {}
            });
        case FETCH_RESET_PASSWORD_SUCCESS:
            return Object.assign({}, state, {
                isResettingPassword: false,
                resetPasswordData: JSON.parse(JSON.stringify(emptyResetPasswordData))
            });
        case FETCH_RESET_PASSWORD_FAILURE:
            return Object.assign({}, state, {
                isResettingPassword: false,
                resetPasswordError: action.error
            });
        case SET_CREDENTIALS:
            return Object.assign({}, state, {
                credentials: action.data
            });
        case SET_RESET_PASSWORD_DATA:
            return Object.assign({}, state, {
                resetPasswordData: action.data
            });
        case SET_TOKEN:
            return Object.assign({}, state, {
                token: action.data
            });
        case SET_USER:
            return Object.assign({}, state, {
                user: action.data
            });
        case UPDATE_AUTH:
            return action.data;
        default:
            return state;
    }
}

export default authReducer;



// WEBPACK FOOTER //
// ./src/containers/Auth/store/reducers.js